'use client'

import React, { useEffect, useState } from 'react'
import { ga4Event } from '@/libs/Google/GoogleTagManager.lib'
import styles from './ArticleDetailHeadInfos.module.scss'
import { Icon } from '@/components/Icon'

export const AudioBtn = ({ item, onClickAction }: { item: any; onClickAction: (e: React.MouseEvent) => void }) => {
  const [toggle, setToggle] = useState(false)
  const [audioUrl, setAudioUrl] = useState<string | undefined>(undefined)

  if (!item.model.audio) {
    return
  }

  useEffect(() => {
    if (toggle) {
      ga4Event({
        eventcategory: 'inline',
        eventaction: 'listen to article',
        eventlabel: audioUrl,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggle])

  return (
    <>
      <div className={styles.infos}>
        <button
          className={styles.audio}
          onClick={(e) => {
            setAudioUrl(item.model.audio?.urls.mp3)
            setToggle((cur) => !cur)
            onClickAction(e)
          }}
        >
          <Icon name={!toggle ? 'audio' : 'close'} />
          <div className={styles['audio-info']}>
            <span className={styles['audio-info-text']}>
              {!toggle ? `Artikel anhören (${item.model.audio.duration} min)` : `Audioplayer schließen`}
            </span>
          </div>
        </button>
      </div>
    </>
  )
}

export default AudioBtn
